import { inject, Injectable } from '@angular/core';
import { SessionStorageService } from '../../../../core/services/session-storage/session-storage.service';
import { OnboardingAssesmentModel } from '../onboarding-assesment-models/onboarding-assesment-model.model';
import { environment } from '../../../../../environments/environment';
import axios, { AxiosError, AxiosRequestConfig } from 'axios';

@Injectable({
  providedIn: 'root'
})
export class OnboardingAssessmentService {


  private sessionStorageService = inject(SessionStorageService);

  constructor() { }

  async saveOnboardingassessment(onboardingAssessment: OnboardingAssesmentModel) {

    const API_URL: string = environment.baseUrl + environment.apis.saveonboardingassessment;

    const REQUEST_CONFIG: AxiosRequestConfig = {
      method: 'POST',
      maxBodyLength: Infinity,
      url: API_URL,
      headers: {
        'Content-Type': 'application/json',
        'Authorization': this.sessionStorageService.getCurrentUserAuthToken()
      },
      data: onboardingAssessment.toString()
    };

    return await axios.request(REQUEST_CONFIG)
      .then((httpResponse) => {
        return JSON.stringify(httpResponse);
      })
      .catch((error) => {
        throw new AxiosError(error.response.data, error.status);
      });
  }

  async viewChecklistdocuments(viewid: number) {

    const API_URL: string = environment.baseUrl + environment.apis.viewchecklistdocuments + `/${viewid}`;

    const REQUEST_CONFIG: AxiosRequestConfig = {
      method: 'GET',
      maxBodyLength: Infinity,
      url: API_URL,
      responseType: 'blob',
      headers: {
        'Content-Type': 'application/pdf',
        'Authorization': this.sessionStorageService.getCurrentUserAuthToken()
      },
    };

    return await axios.request(REQUEST_CONFIG)
      .then((httpResponse) => {
        return new Blob([httpResponse.data], {
          type: 'application/pdf'
        });
      })
      .catch((error) => {
        throw new AxiosError(error.response.data, error.status);
      });
  }

  async viewChecklistdocumentslist(viewid: number) {

    const API_URL: string = environment.baseUrl + environment.apis.viewdocumentslist;

    const REQUEST_CONFIG: AxiosRequestConfig = {
      method: 'POST',
      maxBodyLength: Infinity,
      url: API_URL,
      headers: {
        'Content-Type': 'application/json',
        'Authorization': this.sessionStorageService.getCurrentUserAuthToken()
      },
      data: {
        onboardingId: viewid,
        updatedByRole: this.sessionStorageService.getCurrentUserRole() == 'DSU' || 'DSU Manager' ? ['Onboarding','DSU'] : [this.sessionStorageService.getCurrentUserRole()]
      }
    };

    return await axios.request(REQUEST_CONFIG)
      .then((httpResponse) => {
        return JSON.stringify(httpResponse);
      })
      .catch((error) => {
        throw new AxiosError(error.response.data, error.status);
      });
  }

  async viewDsudocumentslist(viewid: number) {

    const API_URL: string = environment.baseUrl + environment.apis.viewdocumentslist;

    const REQUEST_CONFIG: AxiosRequestConfig = {
      method: 'POST',
      maxBodyLength: Infinity,
      url: API_URL,
      headers: {
        'Content-Type': 'application/json',
        'Authorization': this.sessionStorageService.getCurrentUserAuthToken()
      },
      data: {
        onboardingId: viewid,
        updatedByRole: this.sessionStorageService.getCurrentUserRole() == 'DSU Manager' ? ['DSU'] : [this.sessionStorageService.getCurrentUserRole()]
      }
    };

    return await axios.request(REQUEST_CONFIG)
      .then((httpResponse) => {
        return JSON.stringify(httpResponse);
      })
      .catch((error) => {
        throw new AxiosError(error.response.data, error.status);
      });
  }

  async viewDsumangerdocumentslist(viewid: number) {

    const API_URL: string = environment.baseUrl + environment.apis.viewdocumentslist;

    const REQUEST_CONFIG: AxiosRequestConfig = {
      method: 'POST',
      maxBodyLength: Infinity,
      url: API_URL,
      headers: {
        'Content-Type': 'application/json',
        'Authorization': this.sessionStorageService.getCurrentUserAuthToken()
      },
      data: {
        onboardingId: viewid,
        updatedByRole: [this.sessionStorageService.getCurrentUserRole()]
      }
    };

    return await axios.request(REQUEST_CONFIG)
      .then((httpResponse) => {
        return JSON.stringify(httpResponse);
      })
      .catch((error) => {
        throw new AxiosError(error.response.data, error.status);
      });
  }

  async viewOnboardingassessment(viewid: number) {

    const API_URL: string = environment.baseUrl + environment.apis.viewonboardingassessment;

    const REQUEST_CONFIG: AxiosRequestConfig = {
      method: 'POST',
      maxBodyLength: Infinity,
      url: API_URL,
      headers: {
        'Content-Type': 'application/json',
        'Authorization': this.sessionStorageService.getCurrentUserAuthToken()
      },
      data: {
        "onboardingId": viewid,
        "updatedByRole": this.sessionStorageService.getCurrentUserRole() == 'DSU' || 'DSU Manager' ? 'Onboarding' : [this.sessionStorageService.getCurrentUserRole()],
        "status":'Onboarding Processing',

      }
    };

    return await axios.request(REQUEST_CONFIG)
      .then((httpResponse) => {
        return JSON.stringify(httpResponse);
      })
      .catch((error) => {
        throw new AxiosError(error.response.data, error.status);
      });
  }

  async deleteonbordingdocument(data: any) {
    const API_URL: string = environment.baseUrl + environment.apis.deletedocument;

    const REQUEST_CONFIG: AxiosRequestConfig = {
      method: 'POST',
      maxBodyLength: Infinity,
      url: API_URL,
      headers: {
        'Content-Type': 'application/json',
        'Authorization': this.sessionStorageService.getCurrentUserAuthToken()
      },
      data: {
        onboardingId: data.onboardingId,
        docTypeId: data.docTypeId,
        id: data.id
      }
    };

    return await axios.request(REQUEST_CONFIG)
      .then((httpResponse) => {
        return JSON.stringify(httpResponse);
      })
      .catch((error) => {
        throw new AxiosError(error.response.data, error.status);
      });
  }
}
